var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#40A648"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8154 10H14.1846C11.8809 10 10 11.8809 10 14.1846V25.8154C10 28.1277 11.8809 30 14.1846 30H17.5065C17.981 30 18.3693 29.6117 18.3693 29.1372C18.3693 28.6626 17.981 28.2744 17.5065 28.2744H14.1846C12.83 28.2744 11.7256 27.17 11.7256 25.8154V14.1846C11.7256 12.83 12.83 11.7256 14.1846 11.7256H25.8154C27.17 11.7256 28.2744 12.83 28.2744 14.1846V18.3348C28.2744 18.8093 28.6626 19.1976 29.1372 19.1976C29.6117 19.1976 30 18.8093 30 18.3348V14.1846C30 11.8723 28.1191 10 25.8154 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3349 19.9655H15.8413C15.3668 19.9655 14.9785 20.3537 14.9785 20.8283C14.9785 21.3028 15.3668 21.6911 15.8413 21.6911H18.3349C18.8094 21.6911 19.1977 21.3028 19.1977 20.8283C19.1977 20.3537 18.8094 19.9655 18.3349 19.9655Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8499 17.541H23.3305C23.805 17.541 24.1933 17.1527 24.1933 16.6782C24.1933 16.2036 23.805 15.8153 23.3305 15.8153H15.8499C15.3753 15.8153 14.9871 16.2036 14.9871 16.6782C14.9871 17.1527 15.3753 17.541 15.8499 17.541Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8344 20.7938C27.1787 20.1467 26.1088 20.1467 25.4444 20.7938L20.2158 26.0224C20.0519 26.1864 19.9656 26.4021 19.9656 26.635V29.1286C19.9656 29.6031 20.3538 29.9914 20.8284 29.9914H23.3219C23.5549 29.9914 23.7706 29.8965 23.9345 29.7412L29.1632 24.4866C29.4824 24.1674 29.655 23.736 29.655 23.2873C29.655 22.83 29.4738 22.4073 29.1545 22.088L27.8431 20.7938H27.8344ZM22.9595 28.2744H21.6912V26.9974L26.6265 22.019L27.938 23.2701L22.9595 28.2744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingaction);
export default __webpack_public_path__ + "static/media/bookingaction.da85cb6c7c293da25948aa6f9f91c337.svg";
export { ForwardRef as ReactComponent };